export default "__VITE_ASSET__9abd706f__"